import DataAccess from './constants';
import { genfunction } from '../helpers';

const path = 'userdefinedfields?';

export const apiUserDefinedFields = (params) => {

    var h = new Headers();
    h.append("Authorization", 'Basic ' + genfunction.EncodeBase64(DataAccess.userName + ':' + DataAccess.password));
    h.append('Content-Type', 'application/json');

    let url = DataAccess.apiUrl + path;

    if (params.payload.type === 'Booking') {

        if (params.payload.listOfIds.length < 1) {
            url += "BookingTypeID=" + params.payload.id;
        }
        else {
            url += "BookingTypeIDList=" + params.payload.listOfIds;
        }
    }
    else if (params.payload.type === 'Memberships') {
        if (params.payload.listOfIds.length < 1) {
            url += "MembershipTypeID=" + params.payload.id;
        }
        else {
            url += "MembershipTypeIDList=" + params.payload.listOfIds;
        }
    }

    const req = new Request(url, {
        method: 'GET',
        headers: h
    })

    return fetch(req);
}